import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useContactSingle from "../../data/useContactsSingle";
import useEmails from "../../data/useEmails";
import useSingleLead from "../../data/useSingleLead";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import Modal from "../../layouts/Modal";
import { SendEmailRequest } from "../../models/Email";
import { ILead } from "../../models/Lead";
import classNames from "../../utils/classNames";
import getAddress from "../../utils/getAddress";
import Card from "../shared/Card/Card";
import ConfirmModal from "../shared/Confirm/ConfirmModal";
import { Button } from "../base/Button";
import { IContact } from "../../models/Quote";

type FormValues = {
  fullname: string;
  telephone1: string;
  email: string;
  addressLine1: string;
  addressLine2: string;
  town: string;
  county: string;
  postcode: string;
};

export default function QuoteContactDetails({ contact }: { contact: IContact }) {
  const { update } = useContactSingle(contact?.id!);
  const { sendEmail } = useEmails();
  const [emailOpen, setEmailOpen] = useState(false);
  const [textOpen, setTextOpen] = useState(false);
  const [requestOpen, setRequestOpen] = useState(false);
  const [isRequestLoading, setIsRequestLoading] = useState(false);
  const { saveHandlers } = useDefaultCRUDHandlers("Contact details");
  const { register, getValues, setValue, watch, handleSubmit, reset, control } =
    useForm<FormValues>({
      defaultValues: {
        fullname: contact?.firstName + " " + contact?.lastName,
        telephone1: contact?.telephone1,
        email: contact?.email,
        addressLine1: contact?.addressLine1 ? contact?.addressLine1.trim() : "",
        addressLine2: contact?.addressLine2,
        town: contact?.town,
        county: contact?.county,
        postcode: contact?.postcode,
      },
    });

  const onSubmit = (data: any) => {
    const updatedContact = {
      ...contact,
      ...data,
      contactType: parseInt(data.contactType),
    };

    console.log(updatedContact);
    update.mutate(updatedContact, saveHandlers);

    reset({
      fullname: data.firstName + " " + data.lastName,
      telephone1: data.telephone1,
      email: data.email,
      addressLine1: data.addressLine1,
      addressLine2: data.addressLine2,
      town: data.town,
      county: data.county,
      postcode: data.postcode,
    });
  };



  return (
    <>
      <Card title="Contact Details" bodyClassName="p-4">
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div className="grid grid-cols-1 gap-x-4 gap-y-4 sm:gap-y-8 sm:grid-cols-2">
            <div className="sm:col-span-1 pr-4">
              <label className="text-sm font-medium text-gray-500">Name</label>
              <input
                {...register("fullname")}
                type="text"
                className="w-full mt-1 text-sm text-gray-900 "
              />
            </div>
            <div className="sm:col-span-1 pr-4">
              <label className="text-sm font-medium text-gray-500">
                Email Address
              </label>
              <input
                {...register("email")}
                type="text"
                className="w-full mt-1 text-sm text-gray-900"
              />
            </div>
          </div>

          {/* <hr /> */}

          <div className="grid grid-cols-1 gap-x-4 gap-y-4 sm:gap-y-8 sm:grid-cols-2">
            <div className="sm:col-span-1 pr-4">
              <label className="text-sm font-medium text-gray-500">
                Phone Number
              </label>
              <input
                {...register("telephone1")}
                type="text"
                className="w-full mt-1 text-sm text-gray-900"
              />
            </div>
          </div>

        </form>

        <hr className="mt-4" />

      </Card>
    </>
  );
}
